// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { AddAssetToLibraryApiAssetsAssetIdLibraryPostData, AddAssetToLibraryApiAssetsAssetIdLibraryPostErrors, AddAssetToLibraryApiAssetsAssetIdLibraryPostResponses, AttachProjectAssetApiProjectsProjectIdAssetsPostData, AttachProjectAssetApiProjectsProjectIdAssetsPostErrors, AttachProjectAssetApiProjectsProjectIdAssetsPostResponses, CreateAssetApiAssetsPostData, CreateAssetApiAssetsPostErrors, CreateAssetApiAssetsPostResponses, CreateDesignFromSelectionApiSelectionCreateDesignImageIdPostData, CreateDesignFromSelectionApiSelectionCreateDesignImageIdPostErrors, CreateDesignFromSelectionApiSelectionCreateDesignImageIdPostResponse, CreateDesignFromSelectionApiSelectionCreateDesignImageIdPostResponses, CreateImageAssetApiAssetsImagePostData, CreateImageAssetApiAssetsImagePostErrors, CreateImageAssetApiAssetsImagePostResponses, CreateProjectApiProjectsPostData, CreateProjectApiProjectsPostErrors, CreateProjectApiProjectsPostResponses, DeleteAllSessionsApiSessionsDeleteData, DeleteAllSessionsApiSessionsDeleteErrors, DeleteAllSessionsApiSessionsDeleteResponses, DeleteImageApiImagesImageIdDeleteData, DeleteImageApiImagesImageIdDeleteErrors, DeleteImageApiImagesImageIdDeleteResponses, DeleteSessionApiSessionsSessionIdDeleteData, DeleteSessionApiSessionsSessionIdDeleteErrors, DeleteSessionApiSessionsSessionIdDeleteResponses, DownloadImageApiImagesImageIdDownloadGetData, DownloadImageApiImagesImageIdDownloadGetErrors, DownloadImageApiImagesImageIdDownloadGetResponses, DownloadUpscaledImageApiImagesImageIdDownloadUpscaledGetData, DownloadUpscaledImageApiImagesImageIdDownloadUpscaledGetErrors, DownloadUpscaledImageApiImagesImageIdDownloadUpscaledGetResponses, ExpandElementsApiImagesImageIdParametersExpandElementsPostData, ExpandElementsApiImagesImageIdParametersExpandElementsPostErrors, ExpandElementsApiImagesImageIdParametersExpandElementsPostResponses, ExpandGroupParametersApiImagesImageIdParametersExpandGroupPostData, ExpandGroupParametersApiImagesImageIdParametersExpandGroupPostErrors, ExpandGroupParametersApiImagesImageIdParametersExpandGroupPostResponses, ExtractParametersFromImageApiImagesImageIdParametersPostData, ExtractParametersFromImageApiImagesImageIdParametersPostErrors, ExtractParametersFromImageApiImagesImageIdParametersPostResponses, GenerateImageStreamApiGenerationGeneratePostData, GenerateImageStreamApiGenerationGeneratePostErrors, GenerateImageStreamApiGenerationGeneratePostResponse, GenerateImageStreamApiGenerationGeneratePostResponses, GetGalleryTreeApiSessionsGalleryTreeGetData, GetGalleryTreeApiSessionsGalleryTreeGetErrors, GetGalleryTreeApiSessionsGalleryTreeGetResponses, GetImageAssetsApiImagesImageIdAssetsGetData, GetImageAssetsApiImagesImageIdAssetsGetErrors, GetImageAssetsApiImagesImageIdAssetsGetResponses, GetImageByIdApiImagesImageIdGetData, GetImageByIdApiImagesImageIdGetErrors, GetImageByIdApiImagesImageIdGetResponses, GetImageIterationPathApiImagesImageIdIterationPathGetData, GetImageIterationPathApiImagesImageIdIterationPathGetErrors, GetImageIterationPathApiImagesImageIdIterationPathGetResponses, GetMyStatusApiUsersMeGetData, GetMyStatusApiUsersMeGetErrors, GetMyStatusApiUsersMeGetResponses, GetSessionWithHierarchyApiSessionsSessionIdGetData, GetSessionWithHierarchyApiSessionsSessionIdGetErrors, GetSessionWithHierarchyApiSessionsSessionIdGetResponses, HandleClerkWebhookApiWebhooksClerkPostData, HandleClerkWebhookApiWebhooksClerkPostErrors, HandleClerkWebhookApiWebhooksClerkPostResponses, HealthCheckHealthGetData, HealthCheckHealthGetErrors, HealthCheckHealthGetResponses, ListAssetsApiAssetsGetData, ListAssetsApiAssetsGetErrors, ListAssetsApiAssetsGetResponses, ListCatalogApiAssetsCatalogGetData, ListCatalogApiAssetsCatalogGetErrors, ListCatalogApiAssetsCatalogGetResponses, ListCatalogCategoriesApiAssetsCatalogCategoriesGetData, ListCatalogCategoriesApiAssetsCatalogCategoriesGetErrors, ListCatalogCategoriesApiAssetsCatalogCategoriesGetResponses, ListCatalogManufacturersApiAssetsCatalogManufacturersGetData, ListCatalogManufacturersApiAssetsCatalogManufacturersGetErrors, ListCatalogManufacturersApiAssetsCatalogManufacturersGetResponses, ListCatalogSubcategoriesApiAssetsCatalogSubcategoriesGetData, ListCatalogSubcategoriesApiAssetsCatalogSubcategoriesGetErrors, ListCatalogSubcategoriesApiAssetsCatalogSubcategoriesGetResponses, ListImagesApiImagesGetData, ListImagesApiImagesGetErrors, ListImagesApiImagesGetResponses, ListOrgsApiAdminOrgsGetData, ListOrgsApiAdminOrgsGetErrors, ListOrgsApiAdminOrgsGetResponses, ListProjectAssetsApiProjectsProjectIdAssetsGetData, ListProjectAssetsApiProjectsProjectIdAssetsGetErrors, ListProjectAssetsApiProjectsProjectIdAssetsGetResponses, ListSessionsApiSessionsGetData, ListSessionsApiSessionsGetErrors, ListSessionsApiSessionsGetResponses, ListUsersApiAdminUsersGetData, ListUsersApiAdminUsersGetErrors, ListUsersApiAdminUsersGetResponses, MarkWelcomeVideoSeenApiUsersMeWelcomeVideoSeenPostData, MarkWelcomeVideoSeenApiUsersMeWelcomeVideoSeenPostErrors, MarkWelcomeVideoSeenApiUsersMeWelcomeVideoSeenPostResponses, MoveSessionToProjectApiSessionsSessionIdProjectPatchData, MoveSessionToProjectApiSessionsSessionIdProjectPatchErrors, MoveSessionToProjectApiSessionsSessionIdProjectPatchResponses, PingApiPingGetData, PingApiPingGetErrors, PingApiPingGetResponses, RegenerateWithAttributesApiRefinementRegenerateWithAttributesIdPostData, RegenerateWithAttributesApiRefinementRegenerateWithAttributesIdPostErrors, RegenerateWithAttributesApiRefinementRegenerateWithAttributesIdPostResponse, RegenerateWithAttributesApiRefinementRegenerateWithAttributesIdPostResponses, RegenerateWithPromptApiRefinementRegenerateWithPromptIdPostData, RegenerateWithPromptApiRefinementRegenerateWithPromptIdPostErrors, RegenerateWithPromptApiRefinementRegenerateWithPromptIdPostResponse, RegenerateWithPromptApiRefinementRegenerateWithPromptIdPostResponses, RenameProjectApiProjectsProjectIdPatchData, RenameProjectApiProjectsProjectIdPatchErrors, RenameProjectApiProjectsProjectIdPatchResponses, RenameSessionApiSessionsSessionIdPatchData, RenameSessionApiSessionsSessionIdPatchErrors, RenameSessionApiSessionsSessionIdPatchResponses, ReplaceSelectionWithAssetApiSelectionReplaceAssetImageIdPostData, ReplaceSelectionWithAssetApiSelectionReplaceAssetImageIdPostErrors, ReplaceSelectionWithAssetApiSelectionReplaceAssetImageIdPostResponse, ReplaceSelectionWithAssetApiSelectionReplaceAssetImageIdPostResponses, SaveImageAsAssetApiImagesImageIdSaveAsAssetPostData, SaveImageAsAssetApiImagesImageIdSaveAsAssetPostErrors, SaveImageAsAssetApiImagesImageIdSaveAsAssetPostResponses, ShareAssetWithOrgApiAssetsAssetIdShareWithOrgPostData, ShareAssetWithOrgApiAssetsAssetIdShareWithOrgPostErrors, ShareAssetWithOrgApiAssetsAssetIdShareWithOrgPostResponses, TranscribeAudioApiTranscribePostData, TranscribeAudioApiTranscribePostErrors, TranscribeAudioApiTranscribePostResponses, UpdateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatchData, UpdateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatchErrors, UpdateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatchResponses, UpdateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatchData, UpdateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatchErrors, UpdateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatchResponses, UploadImageApiAssetsImageUploadPostData, UploadImageApiAssetsImageUploadPostErrors, UploadImageApiAssetsImageUploadPostResponses, UploadImageApiImagesUploadPostData, UploadImageApiImagesUploadPostErrors, UploadImageApiImagesUploadPostResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Ping
 *
 * Simple ping endpoint for auth check and health monitoring
 */
export const pingApiPingGet = <ThrowOnError extends boolean = true>(options?: Options<PingApiPingGetData, ThrowOnError>) => (options?.client ?? client).get<PingApiPingGetResponses, PingApiPingGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/ping',
    ...options
});

/**
 * List Users
 *
 * List and search platform users. Admin only.
 */
export const listUsersApiAdminUsersGet = <ThrowOnError extends boolean = true>(options?: Options<ListUsersApiAdminUsersGetData, ThrowOnError>) => (options?.client ?? client).get<ListUsersApiAdminUsersGetResponses, ListUsersApiAdminUsersGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/admin/users',
    ...options
});

/**
 * Update Billing Exempt
 *
 * Toggle a user's billing_exempt status. Admin only.
 */
export const updateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatch = <ThrowOnError extends boolean = true>(options: Options<UpdateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatchResponses, UpdateBillingExemptApiAdminUsersClerkUserIdBillingExemptPatchErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/admin/users/{clerk_user_id}/billing-exempt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Orgs
 *
 * List and search organizations. Admin only.
 */
export const listOrgsApiAdminOrgsGet = <ThrowOnError extends boolean = true>(options?: Options<ListOrgsApiAdminOrgsGetData, ThrowOnError>) => (options?.client ?? client).get<ListOrgsApiAdminOrgsGetResponses, ListOrgsApiAdminOrgsGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/admin/orgs',
    ...options
});

/**
 * Update Org Billing Exempt
 *
 * Toggle an organization's billing_exempt status. Admin only.
 */
export const updateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatch = <ThrowOnError extends boolean = true>(options: Options<UpdateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatchData, ThrowOnError>) => (options.client ?? client).patch<UpdateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatchResponses, UpdateOrgBillingExemptApiAdminOrgsOrgIdBillingExemptPatchErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/admin/orgs/{org_id}/billing-exempt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Assets
 *
 * List assets visible to the current user, newest first.
 *
 * Always returns the user's personal assets. When the request has an
 * active paid-org context, every asset shared with that org is also
 * returned. The frontend splits the result by ``org_id`` into the
 * "My Assets" and "ORG_NAME's Assets" sections.
 */
export const listAssetsApiAssetsGet = <ThrowOnError extends boolean = true>(options?: Options<ListAssetsApiAssetsGetData, ThrowOnError>) => (options?.client ?? client).get<ListAssetsApiAssetsGetResponses, ListAssetsApiAssetsGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/assets',
    ...options
});

/**
 * Create Asset
 *
 * Save a reusable asset (e.g. a color) owned by the current user.
 *
 * Assets are always created as personal; sharing with an org happens
 * after the fact via ``POST /api/assets/{id}/share-with-org``.
 */
export const createAssetApiAssetsPost = <ThrowOnError extends boolean = true>(options: Options<CreateAssetApiAssetsPostData, ThrowOnError>) => (options.client ?? client).post<CreateAssetApiAssetsPostResponses, CreateAssetApiAssetsPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/assets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Image Asset
 *
 * Upload an image and save it as a reusable asset.
 *
 * Accepts JPEG, PNG, and WebP files. The image is stored in the public
 * bucket and the asset's ``value`` is its public URL. Like colors, image
 * assets are always created as personal.
 */
export const createImageAssetApiAssetsImagePost = <ThrowOnError extends boolean = true>(options: Options<CreateImageAssetApiAssetsImagePostData, ThrowOnError>) => (options.client ?? client).post<CreateImageAssetApiAssetsImagePostResponses, CreateImageAssetApiAssetsImagePostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/api/assets/image',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Upload Image
 *
 * Store an image without saving it to the asset library.
 *
 * Backs one-time component replacements: the caller needs a durable URL to
 * attach to the design, but no ``Asset`` row appears in the gallery.
 * Accepts the same formats as ``POST /api/assets/image``.
 */
export const uploadImageApiAssetsImageUploadPost = <ThrowOnError extends boolean = true>(options: Options<UploadImageApiAssetsImageUploadPostData, ThrowOnError>) => (options.client ?? client).post<UploadImageApiAssetsImageUploadPostResponses, UploadImageApiAssetsImageUploadPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/api/assets/image/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List Catalog
 *
 * List manufacturer assets for the Source screen, one page at a time.
 *
 * Every item says whether the current user has already saved it to their
 * library. Repeat ``manufacturer`` to narrow to any of several manufacturers,
 * and ``category_id`` to any of several categories; the two combine.
 * ``subcategory_id`` (repeatable) narrows each selected category to its
 * checked subcategories; a category with none checked shows whole, and a
 * subcategory whose category isn't selected is ignored. Ordered by name;
 * with a search ``q``, only the products it finds, best fit first.
 */
export const listCatalogApiAssetsCatalogGet = <ThrowOnError extends boolean = true>(options?: Options<ListCatalogApiAssetsCatalogGetData, ThrowOnError>) => (options?.client ?? client).get<ListCatalogApiAssetsCatalogGetResponses, ListCatalogApiAssetsCatalogGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/assets/catalog',
    ...options
});

/**
 * List Catalog Manufacturers
 *
 * List the catalog's manufacturers with their product counts, A to Z.
 *
 * Counts are of the products in the selected categories (``category_id``,
 * repeatable), each narrowed by its own subcategories (``subcategory_id``,
 * repeatable), that the search ``q`` finds, so they say what selecting a
 * manufacturer would show.
 * They ignore the manufacturer selection itself, so the list doesn't change
 * as manufacturers are toggled.
 */
export const listCatalogManufacturersApiAssetsCatalogManufacturersGet = <ThrowOnError extends boolean = true>(options?: Options<ListCatalogManufacturersApiAssetsCatalogManufacturersGetData, ThrowOnError>) => (options?.client ?? client).get<ListCatalogManufacturersApiAssetsCatalogManufacturersGetResponses, ListCatalogManufacturersApiAssetsCatalogManufacturersGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/assets/catalog/manufacturers',
    ...options
});

/**
 * List Catalog Categories
 *
 * List the catalog categories that hold products, most populated first.
 *
 * Counts are of the selected manufacturers' products (``manufacturer``,
 * repeatable) that the search ``q`` finds, mirroring the manufacturer list;
 * the order is the whole catalog's, so it doesn't change with the
 * selection. Subcategories narrow only their own category, so they don't
 * change these counts. A category nothing has been placed in (see
 * ``scripts/categorize_catalog.py``) is left out.
 */
export const listCatalogCategoriesApiAssetsCatalogCategoriesGet = <ThrowOnError extends boolean = true>(options?: Options<ListCatalogCategoriesApiAssetsCatalogCategoriesGetData, ThrowOnError>) => (options?.client ?? client).get<ListCatalogCategoriesApiAssetsCatalogCategoriesGetResponses, ListCatalogCategoriesApiAssetsCatalogCategoriesGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/assets/catalog/categories',
    ...options
});

/**
 * List Catalog Subcategories
 *
 * List subcategories of the selected categories, most populated first.
 *
 * Returns [] without a ``category_id`` selection — subcategories only show
 * after a category is selected. Counts are narrowed by ``manufacturer`` and
 * ``q`` (ignoring the subcategory selection itself, so toggling a
 * subcategory doesn't move the other counts).
 */
export const listCatalogSubcategoriesApiAssetsCatalogSubcategoriesGet = <ThrowOnError extends boolean = true>(options?: Options<ListCatalogSubcategoriesApiAssetsCatalogSubcategoriesGetData, ThrowOnError>) => (options?.client ?? client).get<ListCatalogSubcategoriesApiAssetsCatalogSubcategoriesGetResponses, ListCatalogSubcategoriesApiAssetsCatalogSubcategoriesGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/assets/catalog/subcategories',
    ...options
});

/**
 * Add Asset To Library
 *
 * Save a manufacturer asset into the current user's asset library.
 *
 * Idempotent. Returns 404 if the asset is missing or isn't a manufacturer
 * asset.
 */
export const addAssetToLibraryApiAssetsAssetIdLibraryPost = <ThrowOnError extends boolean = true>(options: Options<AddAssetToLibraryApiAssetsAssetIdLibraryPostData, ThrowOnError>) => (options.client ?? client).post<AddAssetToLibraryApiAssetsAssetIdLibraryPostResponses, AddAssetToLibraryApiAssetsAssetIdLibraryPostErrors, ThrowOnError>({ url: '/api/assets/{asset_id}/library', ...options });

/**
 * Share Asset With Org
 *
 * Promote a personal asset to the user's active org.
 *
 * Returns 400 if there is no active org context, and 404 if the asset
 * is missing, owned by another user, or already shared.
 */
export const shareAssetWithOrgApiAssetsAssetIdShareWithOrgPost = <ThrowOnError extends boolean = true>(options: Options<ShareAssetWithOrgApiAssetsAssetIdShareWithOrgPostData, ThrowOnError>) => (options.client ?? client).post<ShareAssetWithOrgApiAssetsAssetIdShareWithOrgPostResponses, ShareAssetWithOrgApiAssetsAssetIdShareWithOrgPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/assets/{asset_id}/share-with-org',
    ...options
});

/**
 * Create Project
 *
 * Create a project folder.
 *
 * When ``parent_project_id`` resolves to an org-shared folder, the new
 * folder inherits the parent's ``org_id`` so the whole subtree is
 * reachable by every member of the org.
 */
export const createProjectApiProjectsPost = <ThrowOnError extends boolean = true>(options: Options<CreateProjectApiProjectsPostData, ThrowOnError>) => (options.client ?? client).post<CreateProjectApiProjectsPostResponses, CreateProjectApiProjectsPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/projects',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rename Project
 *
 * Rename a project the user can reach (own or via org-share).
 *
 * The org-shared root folder cannot be renamed — its display name is
 * derived from the live Clerk org name.
 */
export const renameProjectApiProjectsProjectIdPatch = <ThrowOnError extends boolean = true>(options: Options<RenameProjectApiProjectsProjectIdPatchData, ThrowOnError>) => (options.client ?? client).patch<RenameProjectApiProjectsProjectIdPatchResponses, RenameProjectApiProjectsProjectIdPatchErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/projects/{project_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Project Assets
 *
 * List a project's assets, used (solid) first then unused (dashed).
 *
 * Combines manually attached assets with assets derived from the project's
 * designs; each carries a ``used`` flag for the UI styling.
 */
export const listProjectAssetsApiProjectsProjectIdAssetsGet = <ThrowOnError extends boolean = true>(options: Options<ListProjectAssetsApiProjectsProjectIdAssetsGetData, ThrowOnError>) => (options.client ?? client).get<ListProjectAssetsApiProjectsProjectIdAssetsGetResponses, ListProjectAssetsApiProjectsProjectIdAssetsGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/projects/{project_id}/assets',
    ...options
});

/**
 * Attach Project Asset
 *
 * Attach an existing asset to a project the user can reach.
 *
 * Assets live in the user's global library; this only records membership.
 * Idempotent — attaching an asset already in the project succeeds without
 * duplicating it.
 */
export const attachProjectAssetApiProjectsProjectIdAssetsPost = <ThrowOnError extends boolean = true>(options: Options<AttachProjectAssetApiProjectsProjectIdAssetsPostData, ThrowOnError>) => (options.client ?? client).post<AttachProjectAssetApiProjectsProjectIdAssetsPostResponses, AttachProjectAssetApiProjectsProjectIdAssetsPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/projects/{project_id}/assets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete All Sessions
 *
 * Delete all sessions and their associated images for the current user.
 *
 * Personal-only on purpose: shared org sessions are out of scope for
 * bulk clear, so this endpoint takes no org context.
 */
export const deleteAllSessionsApiSessionsDelete = <ThrowOnError extends boolean = true>(options?: Options<DeleteAllSessionsApiSessionsDeleteData, ThrowOnError>) => (options?.client ?? client).delete<DeleteAllSessionsApiSessionsDeleteResponses, DeleteAllSessionsApiSessionsDeleteErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/sessions',
    ...options
});

/**
 * List Sessions
 *
 * Get paginated list of accessible sessions with their latest image.
 */
export const listSessionsApiSessionsGet = <ThrowOnError extends boolean = true>(options?: Options<ListSessionsApiSessionsGetData, ThrowOnError>) => (options?.client ?? client).get<ListSessionsApiSessionsGetResponses, ListSessionsApiSessionsGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/sessions',
    ...options
});

/**
 * Get Gallery Tree
 *
 * Get projects and sessions for the gallery project drawer.
 *
 * When the request has an active paid-org context, the org's shared root
 * folder is auto-created on first call and rendered as
 * ``{Org Name}'s Projects`` alongside personal projects.
 */
export const getGalleryTreeApiSessionsGalleryTreeGet = <ThrowOnError extends boolean = true>(options?: Options<GetGalleryTreeApiSessionsGalleryTreeGetData, ThrowOnError>) => (options?.client ?? client).get<GetGalleryTreeApiSessionsGalleryTreeGetResponses, GetGalleryTreeApiSessionsGalleryTreeGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/sessions/gallery-tree',
    ...options
});

/**
 * Move Session To Project
 *
 * Assign a design session to a project folder.
 *
 * Moving a session into the org-shared folder grants org-wide access;
 * moving it back out revokes it.
 */
export const moveSessionToProjectApiSessionsSessionIdProjectPatch = <ThrowOnError extends boolean = true>(options: Options<MoveSessionToProjectApiSessionsSessionIdProjectPatchData, ThrowOnError>) => (options.client ?? client).patch<MoveSessionToProjectApiSessionsSessionIdProjectPatchResponses, MoveSessionToProjectApiSessionsSessionIdProjectPatchErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/sessions/{session_id}/project',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Session
 *
 * Delete a single session and its images.
 *
 * Org members can delete sessions in any project shared with their org.
 */
export const deleteSessionApiSessionsSessionIdDelete = <ThrowOnError extends boolean = true>(options: Options<DeleteSessionApiSessionsSessionIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteSessionApiSessionsSessionIdDeleteResponses, DeleteSessionApiSessionsSessionIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/sessions/{session_id}',
    ...options
});

/**
 * Get Session With Hierarchy
 *
 * Get all images in a session organized by iteration hierarchy.
 */
export const getSessionWithHierarchyApiSessionsSessionIdGet = <ThrowOnError extends boolean = true>(options: Options<GetSessionWithHierarchyApiSessionsSessionIdGetData, ThrowOnError>) => (options.client ?? client).get<GetSessionWithHierarchyApiSessionsSessionIdGetResponses, GetSessionWithHierarchyApiSessionsSessionIdGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/sessions/{session_id}',
    ...options
});

/**
 * Rename Session
 *
 * Rename a session the user can reach (own or via org-share).
 */
export const renameSessionApiSessionsSessionIdPatch = <ThrowOnError extends boolean = true>(options: Options<RenameSessionApiSessionsSessionIdPatchData, ThrowOnError>) => (options.client ?? client).patch<RenameSessionApiSessionsSessionIdPatchResponses, RenameSessionApiSessionsSessionIdPatchErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/sessions/{session_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generate Image Stream
 *
 * Start image generation from text prompt and optional reference image and stream results.
 *
 * This endpoint accepts a text prompt (or conversation) and optionally an uploaded image.
 * It preprocesses the input using an LLM to extract design attributes, then immediately
 * streams the generation progress via Server-Sent Events (SSE).
 */
export const generateImageStreamApiGenerationGeneratePost = <ThrowOnError extends boolean = true>(options?: Options<GenerateImageStreamApiGenerationGeneratePostData, ThrowOnError, GenerateImageStreamApiGenerationGeneratePostResponse>) => (options?.client ?? client).sse.post<GenerateImageStreamApiGenerationGeneratePostResponses, GenerateImageStreamApiGenerationGeneratePostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'text',
    url: '/api/generation/generate',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * Regenerate With Prompt
 *
 * Regenerate image(s) with natural language prompt and stream results.
 *
 * This endpoint allows users to refine an existing image using natural language
 * instructions. It supports generating either a single refined image or 4 variations.
 */
export const regenerateWithPromptApiRefinementRegenerateWithPromptIdPost = <ThrowOnError extends boolean = true>(options: Options<RegenerateWithPromptApiRefinementRegenerateWithPromptIdPostData, ThrowOnError, RegenerateWithPromptApiRefinementRegenerateWithPromptIdPostResponse>) => (options.client ?? client).sse.post<RegenerateWithPromptApiRefinementRegenerateWithPromptIdPostResponses, RegenerateWithPromptApiRefinementRegenerateWithPromptIdPostErrors, ThrowOnError>({
    responseType: 'text',
    url: '/api/refinement/regenerate-with-prompt/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Regenerate With Attributes
 *
 * Regenerate image(s) with current attributes and stream results.
 *
 * This endpoint allows users to refine an existing image by directly specifying
 * design attributes/parameters. It supports generating either a single refined
 * image or 4 variations.
 */
export const regenerateWithAttributesApiRefinementRegenerateWithAttributesIdPost = <ThrowOnError extends boolean = true>(options: Options<RegenerateWithAttributesApiRefinementRegenerateWithAttributesIdPostData, ThrowOnError, RegenerateWithAttributesApiRefinementRegenerateWithAttributesIdPostResponse>) => (options.client ?? client).sse.post<RegenerateWithAttributesApiRefinementRegenerateWithAttributesIdPostResponses, RegenerateWithAttributesApiRefinementRegenerateWithAttributesIdPostErrors, ThrowOnError>({
    responseType: 'text',
    url: '/api/refinement/regenerate-with-attributes/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Design From Selection
 *
 * Turn a selected region into a new, independently editable design.
 *
 * Identifies what the region contains, then streams a single image: the
 * selection re-rendered in isolation as the root of a brand-new session, in
 * the same project as the source. An unrecognized selection arrives as an
 * error event with nothing persisted.
 */
export const createDesignFromSelectionApiSelectionCreateDesignImageIdPost = <ThrowOnError extends boolean = true>(options: Options<CreateDesignFromSelectionApiSelectionCreateDesignImageIdPostData, ThrowOnError, CreateDesignFromSelectionApiSelectionCreateDesignImageIdPostResponse>) => (options.client ?? client).sse.post<CreateDesignFromSelectionApiSelectionCreateDesignImageIdPostResponses, CreateDesignFromSelectionApiSelectionCreateDesignImageIdPostErrors, ThrowOnError>({
    responseType: 'text',
    url: '/api/selection/create-design/{image_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Replace Selection With Asset
 *
 * Swap the component in the selected region for a user-picked asset image.
 *
 * Identifies what the region contains, then streams a single image: the
 * source scene with that component replaced. The result is a refinement of
 * the source image in its own session, so Undo walks back to the unswapped
 * scene. An unrecognized selection arrives as an error event with nothing
 * persisted.
 */
export const replaceSelectionWithAssetApiSelectionReplaceAssetImageIdPost = <ThrowOnError extends boolean = true>(options: Options<ReplaceSelectionWithAssetApiSelectionReplaceAssetImageIdPostData, ThrowOnError, ReplaceSelectionWithAssetApiSelectionReplaceAssetImageIdPostResponse>) => (options.client ?? client).sse.post<ReplaceSelectionWithAssetApiSelectionReplaceAssetImageIdPostResponses, ReplaceSelectionWithAssetApiSelectionReplaceAssetImageIdPostErrors, ThrowOnError>({
    responseType: 'text',
    url: '/api/selection/replace-asset/{image_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Images
 *
 * Get paginated list of images accessible to the current user.
 */
export const listImagesApiImagesGet = <ThrowOnError extends boolean = true>(options?: Options<ListImagesApiImagesGetData, ThrowOnError>) => (options?.client ?? client).get<ListImagesApiImagesGetResponses, ListImagesApiImagesGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/images',
    ...options
});

/**
 * Upload Image
 *
 * Upload an image as the root of a new session, without generation.
 *
 * The uploaded image becomes the base for refinement: design type is
 * detected from the image, a session is created, and the returned image
 * has no parameter groups so the refine screen auto-extracts them.
 */
export const uploadImageApiImagesUploadPost = <ThrowOnError extends boolean = true>(options: Options<UploadImageApiImagesUploadPostData, ThrowOnError>) => (options.client ?? client).post<UploadImageApiImagesUploadPostResponses, UploadImageApiImagesUploadPostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/api/images/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete Image
 *
 * Delete an image. Org members can delete images in org-shared folders.
 */
export const deleteImageApiImagesImageIdDelete = <ThrowOnError extends boolean = true>(options: Options<DeleteImageApiImagesImageIdDeleteData, ThrowOnError>) => (options.client ?? client).delete<DeleteImageApiImagesImageIdDeleteResponses, DeleteImageApiImagesImageIdDeleteErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/images/{image_id}',
    ...options
});

/**
 * Get Image By Id
 *
 * Get image by ID (user must reach it via ownership or org-share).
 */
export const getImageByIdApiImagesImageIdGet = <ThrowOnError extends boolean = true>(options: Options<GetImageByIdApiImagesImageIdGetData, ThrowOnError>) => (options.client ?? client).get<GetImageByIdApiImagesImageIdGetResponses, GetImageByIdApiImagesImageIdGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/images/{image_id}',
    ...options
});

/**
 * Get Image Assets
 *
 * List the assets used within this image (iteration), newest first.
 *
 * Derived from the assets the user picked for color parameters during
 * refinement. Powers the design-details "Assets" section.
 */
export const getImageAssetsApiImagesImageIdAssetsGet = <ThrowOnError extends boolean = true>(options: Options<GetImageAssetsApiImagesImageIdAssetsGetData, ThrowOnError>) => (options.client ?? client).get<GetImageAssetsApiImagesImageIdAssetsGetResponses, GetImageAssetsApiImagesImageIdAssetsGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/images/{image_id}/assets',
    ...options
});

/**
 * Save Image As Asset
 *
 * Save a generated design image into the caller's asset library.
 *
 * Copies the stored PNG into the public asset bucket rather than making the
 * client download and re-upload it. Like every other asset, the new one is
 * personal until it is explicitly shared with an org.
 */
export const saveImageAsAssetApiImagesImageIdSaveAsAssetPost = <ThrowOnError extends boolean = true>(options: Options<SaveImageAsAssetApiImagesImageIdSaveAsAssetPostData, ThrowOnError>) => (options.client ?? client).post<SaveImageAsAssetApiImagesImageIdSaveAsAssetPostResponses, SaveImageAsAssetApiImagesImageIdSaveAsAssetPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/images/{image_id}/save-as-asset',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Download Image
 *
 * Download image file. Bypasses CORS by proxying through API.
 */
export const downloadImageApiImagesImageIdDownloadGet = <ThrowOnError extends boolean = true>(options: Options<DownloadImageApiImagesImageIdDownloadGetData, ThrowOnError>) => (options.client ?? client).get<DownloadImageApiImagesImageIdDownloadGetResponses, DownloadImageApiImagesImageIdDownloadGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/images/{image_id}/download',
    ...options
});

/**
 * Download Upscaled Image
 *
 * Download an upscaled copy of the image (2x or 4x via Topaz Gigapixel).
 *
 * Paid-plan only, unlike the rest of the design endpoints: the free
 * allowance buys generations, not Topaz megapixels. The original-resolution
 * download beside it stays open to everyone.
 */
export const downloadUpscaledImageApiImagesImageIdDownloadUpscaledGet = <ThrowOnError extends boolean = true>(options: Options<DownloadUpscaledImageApiImagesImageIdDownloadUpscaledGetData, ThrowOnError>) => (options.client ?? client).get<DownloadUpscaledImageApiImagesImageIdDownloadUpscaledGetResponses, DownloadUpscaledImageApiImagesImageIdDownloadUpscaledGetErrors, ThrowOnError>({
    responseType: 'blob',
    url: '/api/images/{image_id}/download/upscaled',
    ...options
});

/**
 * Extract Parameters From Image
 *
 * Extract design parameters from an image using vision model.
 */
export const extractParametersFromImageApiImagesImageIdParametersPost = <ThrowOnError extends boolean = true>(options: Options<ExtractParametersFromImageApiImagesImageIdParametersPostData, ThrowOnError>) => (options.client ?? client).post<ExtractParametersFromImageApiImagesImageIdParametersPostResponses, ExtractParametersFromImageApiImagesImageIdParametersPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/images/{image_id}/parameters',
    ...options
});

/**
 * Expand Group Parameters
 *
 * Expand parameters within a specific element group using vision analysis.
 */
export const expandGroupParametersApiImagesImageIdParametersExpandGroupPost = <ThrowOnError extends boolean = true>(options: Options<ExpandGroupParametersApiImagesImageIdParametersExpandGroupPostData, ThrowOnError>) => (options.client ?? client).post<ExpandGroupParametersApiImagesImageIdParametersExpandGroupPostResponses, ExpandGroupParametersApiImagesImageIdParametersExpandGroupPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/images/{image_id}/parameters/expand-group',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Expand Elements
 *
 * Expand with new element groups using vision analysis.
 */
export const expandElementsApiImagesImageIdParametersExpandElementsPost = <ThrowOnError extends boolean = true>(options: Options<ExpandElementsApiImagesImageIdParametersExpandElementsPostData, ThrowOnError>) => (options.client ?? client).post<ExpandElementsApiImagesImageIdParametersExpandElementsPostResponses, ExpandElementsApiImagesImageIdParametersExpandElementsPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/images/{image_id}/parameters/expand-elements',
    ...options
});

/**
 * Get Image Iteration Path
 *
 * Get the full iteration path from root to a specific image.
 */
export const getImageIterationPathApiImagesImageIdIterationPathGet = <ThrowOnError extends boolean = true>(options: Options<GetImageIterationPathApiImagesImageIdIterationPathGetData, ThrowOnError>) => (options.client ?? client).get<GetImageIterationPathApiImagesImageIdIterationPathGetResponses, GetImageIterationPathApiImagesImageIdIterationPathGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/images/{image_id}/iteration-path',
    ...options
});

/**
 * Transcribe Audio
 *
 * Transcribe an uploaded audio file to text using Gemini.
 *
 * Accepts audio files in common formats (MP3, WAV, M4A, WebM, OGG).
 * Returns the transcribed text.
 */
export const transcribeAudioApiTranscribePost = <ThrowOnError extends boolean = true>(options: Options<TranscribeAudioApiTranscribePostData, ThrowOnError>) => (options.client ?? client).post<TranscribeAudioApiTranscribePostResponses, TranscribeAudioApiTranscribePostErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/api/transcribe/',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get My Status
 *
 * Get the current user's free-plan usage and onboarding status.
 */
export const getMyStatusApiUsersMeGet = <ThrowOnError extends boolean = true>(options?: Options<GetMyStatusApiUsersMeGetData, ThrowOnError>) => (options?.client ?? client).get<GetMyStatusApiUsersMeGetResponses, GetMyStatusApiUsersMeGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/users/me',
    ...options
});

/**
 * Mark Welcome Video Seen
 *
 * Record that the onboarding welcome video has been shown to this user.
 *
 * Authenticated-only, not subscription-gated: onboarding isn't a design feature.
 */
export const markWelcomeVideoSeenApiUsersMeWelcomeVideoSeenPost = <ThrowOnError extends boolean = true>(options?: Options<MarkWelcomeVideoSeenApiUsersMeWelcomeVideoSeenPostData, ThrowOnError>) => (options?.client ?? client).post<MarkWelcomeVideoSeenApiUsersMeWelcomeVideoSeenPostResponses, MarkWelcomeVideoSeenApiUsersMeWelcomeVideoSeenPostErrors, ThrowOnError>({ url: '/api/users/me/welcome-video-seen', ...options });

/**
 * Handle Clerk Webhook
 *
 * Receive and process Clerk webhook events.
 *
 * Verifies the Svix signature, then dispatches to the appropriate
 * handler to sync data with Attio CRM and our own user records.
 */
export const handleClerkWebhookApiWebhooksClerkPost = <ThrowOnError extends boolean = true>(options?: Options<HandleClerkWebhookApiWebhooksClerkPostData, ThrowOnError>) => (options?.client ?? client).post<HandleClerkWebhookApiWebhooksClerkPostResponses, HandleClerkWebhookApiWebhooksClerkPostErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/webhooks/clerk',
    ...options
});

/**
 * Health Check
 */
export const healthCheckHealthGet = <ThrowOnError extends boolean = true>(options?: Options<HealthCheckHealthGetData, ThrowOnError>) => (options?.client ?? client).get<HealthCheckHealthGetResponses, HealthCheckHealthGetErrors, ThrowOnError>({
    responseType: 'json',
    url: '/health',
    ...options
});
